import { render, staticRenderFns } from "./ArticleEdit.vue?vue&type=template&id=9a95e02e&scoped=true&"
import script from "./ArticleEdit.vue?vue&type=script&lang=js&"
export * from "./ArticleEdit.vue?vue&type=script&lang=js&"
import style0 from "./ArticleEdit.vue?vue&type=style&index=0&id=9a95e02e&prod&lang=css&"
import style1 from "./ArticleEdit.vue?vue&type=style&index=1&id=9a95e02e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a95e02e",
  null
  
)

export default component.exports